export default __webpack_public_path__ + "static/img4@2x-2fd878297829743ce7e903b40cbd2a4f.jpg";